import z from 'zod';
import { createIdSchema } from '../../lib/util/id.js';
import { createStrictSchema } from '../../lib/util/zod-helpers.js';
import { WorkoutPlanInfoIdSchema } from '../workout/workout.types.js';
import { sectionTypes } from './section.constants.js';
// ===== ID SCHEMAS =====
const SectionPlanIdSchema = createIdSchema('sectionPlan');
const SectionPlanTableSelectSchema = createStrictSchema()({
    id: SectionPlanIdSchema,
    workoutPlanId: WorkoutPlanInfoIdSchema,
    sectionType: z.enum(sectionTypes),
    orderInWorkoutPlan: z.number(),
    name: z.string().nullable(),
    notes: z.string().nullable(),
    rounds: z.number().nullable(),
    durationSeconds: z.number().nullable(),
    intervalSeconds: z.number().nullable(),
    trackTime: z.boolean(),
    createdAt: z.date(),
    updatedAt: z.date(),
    deletedAt: z.date().nullable(),
});
// ===== PUBLIC SCHEMAS (to be used by outer layers) =====
const SectionPlanInfoSchema = SectionPlanTableSelectSchema.omit({
    createdAt: true,
    deletedAt: true,
}).extend({
    updatedAt: z.string(), // ISO date string for API
});
const SectionPlanInfoIdSchema = SectionPlanIdSchema;
export { SectionPlanInfoIdSchema, SectionPlanInfoSchema, SectionPlanTableSelectSchema };
//# sourceMappingURL=section.types.js.map